module.exports = __webpack_public_path__ + "img/electronic_electric_use.0eddf5b3.svg";